/* eslint-disable import/order */
import { onboardingHubWizardWithDelegatedAdminEntryPoint } from '@jira/admin-pages__onboarding-hub-wizard-entry/src/onboardingHubWizardWithDelegatedAdminEntryPoint.entrypoint.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { productsOnboardingHubEditRoute } from '@jira/router-routes__admin-pages-onboarding-hub-routes/src/productsOnboardingHubEditRoute.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { nav4SidebarGlobalProductsSettingsEntryPoint } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-products/src/nav4SidebarGlobalProductsSettingsEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const productsOnboardingHubEditWithDelegatedAdminEntryPoint = createPageEntryPoint({
	main: onboardingHubWizardWithDelegatedAdminEntryPoint,
	leftSidebar: {
		sidebar: nav4SidebarGlobalProductsSettingsEntryPoint,
	},
});

export const productsOnboardingHubEditRouteEntry: Route = createEntry(
	productsOnboardingHubEditRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.products.onboarding-hub-edit',
		meta: {
			reporting: {
				id: 'products-onboarding-hub-edit',
				teamName: 'a4t-pandora',
				packageName: 'jira-router-routes-admin-pages-onboarding-hub-entries',
			},
		},
		entryPoint() {
			if (fg('jira-onboarding-hub-gate')) {
				return productsOnboardingHubEditWithDelegatedAdminEntryPoint;
			}
			return undefined;
		},
		layout: globalSettingsLayout,
		navigation: {
			menuId: MenuIdSettings,
			sidebarId: SidebarIdGlobalProductsSettings,
		},
		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
